const Routes = {
  orders: '/orders',
  account: '/user/personal',
  offers: '/#offers',
  about: '/#about',
  root: '/',
  referalOrders: '/user/referal_orders'
};

exports.Routes = Routes;
// export default Routes;
